// extracted by mini-css-extract-plugin
module.exports = {"loading_cont":"blobs-module--loading_cont--1h5yf","loader":"blobs-module--loader--1mDNk","blobs":"blobs-module--blobs--3eSlE","blob":"blobs-module--blob--2aq-p"};